import { FC, useMemo } from 'react';
import { sortTemplateTypesByRank } from '../templateManagement.constants';
import TemplateTypeChip from './TemplateTypeChip';

export const TemplateMoreInformationContent: FC = () => {
  const templateTypesByRank = useMemo(() => sortTemplateTypesByRank(), []);

  return (
    <div className="text-sm text-gray-800">
      <p className="mb-3 leading-relaxed">
        Templates are reusable content blocks inserted into documents. To manage a
        template, follow these steps:
      </p>
      <ol className="mb-4 list-decimal space-y-3 pl-5 leading-relaxed">
        <li>
          <span className="block">
            Select a template from the list. Each template has a type that controls
            where it applies, ranked from broadest to most specific:
          </span>
          <ul className="mt-2 flex flex-wrap gap-1.5">
            {templateTypesByRank.map((type) => (
              <li key={type} className="list-none">
                <TemplateTypeChip templateType={type} size="sm" />
              </li>
            ))}
          </ul>
        </li>
        <li>Edit the template content and formatting in the editor panel.</li>
        <li>
          Use the document preview to check how your changes look in each affected
          document before saving.
        </li>
        <li>
          Click <strong>Update Content</strong> to apply changes to all affected
          documents, or <strong>Deactivate</strong> to remove the template from them.
          Use <strong>Edit details</strong> to rename the template.
        </li>
      </ol>

      <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
        <p className="mb-2 font-semibold text-blue-900">Important to note</p>
        <p className="mb-2 leading-relaxed text-blue-800">
          Updating a template changes the layout of every affected document and
          increases their version numbers. Significant edits can dramatically shift how
          documents render.
        </p>
        <p className="leading-relaxed text-blue-800">
          Always review the document preview before confirming an update.
        </p>
      </div>
    </div>
  );
};

export default TemplateMoreInformationContent;
